// extracted by mini-css-extract-plugin
export default {"container":"NavigationComponent_container__oG-hT","label":"NavigationComponent_label__jP9qx"};